import { render, staticRenderFns } from "./step-intent-mapping.vue?vue&type=template&id=3873dbd2&scoped=true"
import script from "./step-intent-mapping.vue?vue&type=script&lang=js"
export * from "./step-intent-mapping.vue?vue&type=script&lang=js"
import style0 from "./step-intent-mapping.vue?vue&type=style&index=0&id=3873dbd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3873dbd2",
  null
  
)

export default component.exports